





























import IconItemCategory from "@/common/components/icons/IconItemCategory.vue";
import IconPoint from "@/common/components/icons/IconPoint.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import LocalStorage from "@/general/utils/storage";

@Component({
  components: {
    IconItemCategory,
    IconPoint,
    ButtonMain
  }
})
export default class G01ItemListGroupHeader extends Vue {
  @Prop({ type: String, required: true, default: "" }) id!: string;
  @Prop({ type: String, required: true, default: "" }) label!: string;
  @Prop({ type: Boolean, required: true, default: true }) isCategory!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) isFirst!: boolean;

  get unit() {
    return commons?.OrgPageSpecific?.point_name;
  }
  get isPointRangeFirst() {
    return this.id === "item-point-range0";
  }
  get isPointRangeLast() {
    return this.id === "item-point-range5";
  }

  goToProductList() {
    LocalStorage.setItem("productListSort", "popularity");
    window.location.href = "/product-list/?product-category=" + this.id;
  }
}
